import {
    GET_CARRIER_CONNECT_LISTING_REQUEST,
    GET_CARRIER_CONNECT_LISTING_SUCCESS,
    GET_CARRIER_CONNECT_LISTING_FAILURE,
    GET_CARRIER_CONNECT_BY_ID_REQUEST,
    GET_CARRIER_CONNECT_BY_ID_SUCCESS,
    GET_CARRIER_CONNECT_BY_ID_FAILURE,
    CREATE_CARRIER_CONNECT_REQUEST,
    CREATE_CARRIER_CONNECT_SUCCESS,
    CREATE_CARRIER_CONNECT_FAILURE,
    UPDATE_CARRIER_CONNECT_REQUEST,
    UPDATE_CARRIER_CONNECT_SUCCESS,
    UPDATE_CARRIER_CONNECT_FAILURE,
    DELETE_CARRIER_CONNECT_REQUEST,
    DELETE_CARRIER_CONNECT_SUCCESS,
    DELETE_CARRIER_CONNECT_FAILURE,
    TEST_CARRIER_CONNECTION_REQUEST,
    TEST_CARRIER_CONNECTION_SUCCESS,
    TEST_CARRIER_CONNECTION_FAILURE,
    GET_CARRIER_CONNECT_CARRIERS_SUCCESS,
    GET_CARRIER_CONNECT_TYPES_SUCCESS,
    GET_CARRIER_CONNECT_STATUS_SUCCESS,
    GET_CARRIER_CONNECT_HISTORY_REQUEST,
    GET_CARRIER_CONNECT_HISTORY_SUCCESS,
    GET_CARRIER_CONNECT_HISTORY_FAILURE
} from '../actions/carrierConnect.action';

const initialState = {
    carrierConnectData: null,
    carrierConnectDetails: null,
    carrierConnectStatus: 'idle', // idle, pending, success, failure
    carrierConnectHistory: null,
    carrierConnectHistoryStatus: 'idle', // idle, pending, success, failure
    carrierConnectCarriers: [],
    carrierConnectTypes: [],
    carrierConnectAllStatus: [],
    error: null,
    loading: false,
    testResults: null
};

const carrierConnectReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CARRIER_CONNECT_LISTING_REQUEST:
            return {
                ...state,
                carrierConnectStatus: 'pending',
                loading: true,
                error: null
            };
            
        case GET_CARRIER_CONNECT_LISTING_SUCCESS:
            return {
                ...state,
                carrierConnectStatus: 'success',
                carrierConnectData: action.payload,
                loading: false,
                error: null
            };
            
        case GET_CARRIER_CONNECT_LISTING_FAILURE:
            return {
                ...state,
                carrierConnectStatus: 'failure',
                loading: false,
                error: action.payload
            };

        case GET_CARRIER_CONNECT_BY_ID_REQUEST:
        case CREATE_CARRIER_CONNECT_REQUEST:
        case UPDATE_CARRIER_CONNECT_REQUEST:
        case DELETE_CARRIER_CONNECT_REQUEST:
        case TEST_CARRIER_CONNECTION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case GET_CARRIER_CONNECT_BY_ID_SUCCESS:
            return {
                ...state,
                carrierConnectDetails: action.payload,
                loading: false,
                error: null
            };
            
        case CREATE_CARRIER_CONNECT_SUCCESS:
        case UPDATE_CARRIER_CONNECT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
            
        case GET_CARRIER_CONNECT_BY_ID_FAILURE:
        case CREATE_CARRIER_CONNECT_FAILURE:
        case UPDATE_CARRIER_CONNECT_FAILURE:
        case DELETE_CARRIER_CONNECT_FAILURE:
        case TEST_CARRIER_CONNECTION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case DELETE_CARRIER_CONNECT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                carrierConnectData: {
                    ...state.carrierConnectData,
                    CarrierConnections: state.carrierConnectData?.CarrierConnections?.filter(
                        item => item.id !== action.payload
                    ) || []
                }
            };

        case TEST_CARRIER_CONNECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                testResults: action.payload,
                error: null
            };

        case GET_CARRIER_CONNECT_CARRIERS_SUCCESS:
            return {
                ...state,
                carrierConnectCarriers: action.payload
            };
            
        case GET_CARRIER_CONNECT_TYPES_SUCCESS:
            return {
                ...state,
                carrierConnectTypes: action.payload
            };
            
        case GET_CARRIER_CONNECT_STATUS_SUCCESS:
            return {
                ...state,
                carrierConnectAllStatus: action.payload
            };

        case GET_CARRIER_CONNECT_HISTORY_REQUEST:
            return {
                ...state,
                carrierConnectHistoryStatus: 'pending',
                loading: true,
                error: null
            };
            
        case GET_CARRIER_CONNECT_HISTORY_SUCCESS:
            return {
                ...state,
                carrierConnectHistoryStatus: 'success',
                carrierConnectHistory: action.payload,
                loading: false,
                error: null
            };
            
        case GET_CARRIER_CONNECT_HISTORY_FAILURE:
            return {
                ...state,
                carrierConnectHistoryStatus: 'failure',
                loading: false,
                error: action.payload
            };
        
        default:
            return state;
    }
};

export default carrierConnectReducer;
